// src/app/layout/core-nav-items.ts
import {
  LayoutDashboard,
  Building2,
  Users,
  Server,
  ShoppingCart,
  Wallet,
  Percent,
  ShieldCheck,
  ScrollText,
  ActivitySquare,
  BarChart3,
  Settings,
  LockKeyhole,
  type LucideIcon,
} from 'lucide-react';

export interface CoreNavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  permission?: string;
  section: 'Core' | 'Security' | 'System';
}

export const CORE_NAV_ITEMS: CoreNavItem[] = [
  { label: 'داشبورد', to: '/dashboard', icon: LayoutDashboard, section: 'Core' },

  { label: 'تننت‌ها', to: '/tenants', icon: Building2, section: 'Core' },

  { label: 'کاربران', to: '/users', icon: Users, section: 'Core' },

  { label: 'سرویس‌ها', to: '/services', icon: Server, section: 'Core' },

  { label: 'سفارش‌ها', to: '/orders', icon: ShoppingCart, section: 'Core' },

  { label: 'کیف پول', to: '/wallet', icon: Wallet, section: 'Core' },

  { label: 'کمیسیون', to: '/commission', icon: Percent, section: 'Core' },


  { label: 'مرکز امنیت', to: '/security', icon: ShieldCheck, section: 'Security' },

  { label: 'گزارش رخدادها', to: '/audit', icon: ScrollText, section: 'Security' },

  { label: 'دسترسی‌ها', to: '/permissions', icon: LockKeyhole, section: 'Security' },


  { label: 'مانیتورینگ', to: '/monitoring', icon: ActivitySquare, section: 'System' },

  { label: 'تحلیل‌ها', to: '/analytics', icon: BarChart3, section: 'System' },

  { label: 'تنظیمات', to: '/settings', icon: Settings, section: 'System' },
];


export const CORE_NAV_SECTION_LABELS: Record<CoreNavItem['section'], string> = {
  Core: 'هسته',
  Security: 'امنیت',
  System: 'سیستم',
};
